import * as yup from 'yup';

const ZIP_RE = /^\d{5}(-\d{4})?$/;

yup.addMethod(yup.string, 'zip', function zip(message?: yup.Message) {
    return this.matches(
        ZIP_RE,
        message || (({ path }) => `${path} is an invalid Zip`)
    );
});

export { yup };
